import { Leaf, Ruler, Package, Scissors, Truck, RotateCcw } from "lucide-react";

const ITEMS = [
  { Icon: Leaf, title: "Full-Grain", subtitle: "Real leather, by hand" },
  { Icon: Ruler, title: "Tailored Fit", subtitle: "For real bodies" },
  { Icon: Package, title: "Eco-Friendly", subtitle: "Recycled packaging" },
  { Icon: Scissors, title: "Made One at a Time", subtitle: "In Sialkot" },
  { Icon: Truck, title: "Free Shipping", subtitle: "Worldwide" },
  { Icon: RotateCcw, title: "30 Days", subtitle: "Easy returns" },
] as const;

/**
 * Editorial benefits strip — six trust points sitting in a quiet bone band.
 */
export function BenefitsStrip() {
  return (
    <section aria-label="Why KAKAIYS" className="bg-bone border-y border-border">
      <div className="container-luxe py-10 md:py-14">
        <ul className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-y-10 gap-x-6">
          {ITEMS.map(({ Icon, title, subtitle }) => (
            <li key={title} className="flex flex-col items-center text-center">
              <Icon className="h-7 w-7 text-ink/80 mb-4" strokeWidth={1.25} />
              <div className="text-[12px] uppercase tracking-[0.28em] text-ink font-light">
                {title}
              </div>
              <div className="mt-1.5 text-[10px] uppercase tracking-[0.24em] text-stone">
                {subtitle}
              </div>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
